import React from 'react'
import { useTranslation } from 'react-i18next'
import { ItemApi } from 'appTypes/items'
import { ProductCardHorizontal } from 'components/ui/Card/ProductCardHorizontal'
import { Box, DataList, Heading } from '@chakra-ui/react'
import { Text } from '@chakra-ui/react'
import { Flex } from '@chakra-ui/react'

type Props = {
  product: ItemApi
  isBundle: boolean
}

const ProductInformation = ({ product, isBundle }: Props) => {
  const { t } = useTranslation(['common'])
  const singleProduct = product.products[0]

  if (!singleProduct) {
    return null
  }

  return isBundle ? (
    <>
      {product.complementaryItems && (
        <>
          <Text marginY="12px" fontSize="xs">
            {t('accessories')}
          </Text>
          {product.complementaryItems.map((item, index) => (
            <Box key={index} marginBottom="20px" className="gtm-complementary-item-wrapper">
              <ProductCardHorizontal product={item.products[0]} isDark={true} price={item.price} />
            </Box>
          ))}
        </>
      )}
    </>
  ) : (
    <Box display="flex" gap="60px" flexDirection={{ base: 'column', lg: 'row' }}>
      {singleProduct.technicalDetails && singleProduct.technicalDetails.length >= 1 && (
        <Box width={{ base: '100%', lg: '30%' }}>
          <Heading fontWeight="semibold" as="h5" marginTop="40px" marginBottom="30px" lineHeight="auto">
            {t('technicalInfo')}
          </Heading>
          <DataList.Root orientation="horizontal" divideY="1px" width="100%">
            {singleProduct.technicalDetails.map((item, index) => (
              <DataList.Item key={`${item.name}_${item.value}-${index}`} pt="6">
                <DataList.ItemLabel fontSize="normal" lineHeight="normal">
                  {item.name}
                </DataList.ItemLabel>
                <DataList.ItemValue
                  fontSize="normal"
                  fontWeight="normal"
                  textAlign="end"
                  display="flex"
                  justifyContent="end"
                  lineHeight="normal"
                >
                  {item.value}
                </DataList.ItemValue>
              </DataList.Item>
            ))}
          </DataList.Root>
        </Box>
      )}
      {product.complementaryItems && (
        <Box width={{ base: '100%', lg: '30%' }}>
          <Heading fontWeight="semibold" as="h5" marginTop="40px" marginBottom="30px">
            {t('accessories')}
          </Heading>
          {product.complementaryItems.map((item, index) => (
            <Flex
              key={index}
              marginBottom="20px"
              justifyContent="space-between"
              width="100%"
              className="gtm-complementary-item-wrapper"
            >
              <ProductCardHorizontal product={item.products[0]} isDark={true} price={item.price} />
            </Flex>
          ))}
        </Box>
      )}{' '}
    </Box>
  )
}

export default ProductInformation
